// src/menuConfig.ts

import type { AppMenuEntry } from "./menu/types";

import { AUTOMATION_MENU } from "./menu/sections/automationMenu";
import { CA_MENU } from "./menu/sections/caMenu";
import { IAM_MENU } from "./menu/sections/iamMenu";
import { DNS_MENU } from "./menu/sections/dnsMenu";
// import other groups:
import { SHARES_MENU } from "./menu/sections/sharesMenu";
import { PROJECT_MENU } from "./menu/sections/projectMenu";
import { SSH_MENU } from "./menu/sections/sshMenu";
import { IPAM_MENU } from "./menu/sections/ipamMenu";
import { CRON_MENU } from "./menu/sections/cronMenu";
import { MONITOR_MENU } from "./menu/sections/monitorMenu";
import { HOST_MENU } from "./menu/sections/hostMenu";
import { APPS_MENU } from "./menu/sections/appsMenu";
import { PAGES_MENU } from "./menu/sections/pagesMenu";
import { AUTH_MENU } from "./menu/sections/authMenu";
import { WIKI_MENU } from "./menu/sections/wikiMenu";

export const APP_MENU: AppMenuEntry[] = [
  AUTOMATION_MENU,
  CA_MENU,
  HOST_MENU,
  IPAM_MENU,
  PROJECT_MENU,
  DNS_MENU,
  WIKI_MENU,
  MONITOR_MENU,
  AUTH_MENU,
  IAM_MENU,
  CRON_MENU,
  // these need work
  //  SHARES_MENU,
  SSH_MENU,
  APPS_MENU,
  PAGES_MENU,
];

// re-export types if convenient
export type { AppMenuEntry, AppMenuLeaf, AppMenuGroup } from "./menu/types";
